import { MainStaffComponent } from "./components/main-staff.component";
import {RouterModule, Routes} from "@angular/router";
import { NgModule } from '@angular/core';
import { AuthService } from '../../injections/auth.service';
import { StaffService } from '../../injections/staff.service';

export const appRoutes: Routes = [
    {
        path: 'staff',
        component: MainStaffComponent,
        canActivate: [StaffService]
    },
    
];


@NgModule({
    imports: [
        RouterModule.forChild(appRoutes)
    ],
    exports: [
        RouterModule
    ],
    declarations: [],
    providers: [],
})
export class ExportsRoutes { }


// WEBPACK FOOTER //
// ./src/app/modules/staff/staff.routes.ts